<template>
<!--Select profile from frontpage-->
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" class=" pl-2">
        Admin
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in admin" :key="index" :to="item.link">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// i18n imported
import messages from "../../modules/lang/export";
export default {
  // i18n used
  i18n: { messages },
  data() {
    return {
      admin: [
        {
          name: "Dashboard",
          link: "admin/Dashboard"
        },
        {
          name: "Tools",
          link: "admin/tools"
        },
        {
          name: "Reports",
          link: "admin/Report"
        },
        { name: this.$t("navbar.general.Logout"), link: "logout" }
      ]
    };
  }
};
</script>
